import dayjs from 'dayjs'
import { HistoryLesson, ScheduleHistoryPresentation } from '@/api/changeHistory'
import cn from './index.module.css'

const lessonDate = (lesson?: HistoryLesson) => {
  if (!lesson) return '—'
  const date = lesson.date && dayjs(lesson.date).isValid() ? dayjs(lesson.date).format('DD.MM.YYYY') : ''
  return [date, [lesson.start_time, lesson.end_time].filter(Boolean).join('–')].filter(Boolean).join(' ') || '—'
}

export const ScheduleLessonCell = ({ value }: { value: ScheduleHistoryPresentation }) => (
  <div className={cn.cell}>
    {(value.after.length ? value.after : value.before).map((lesson, index) => (
      <div key={`${lesson.id}-${index}`} className={cn.lesson}>
        <div className={cn.lessonTitle}>{lesson.subject || 'Занятие'}</div>
        <div className={cn.meta}>{[lesson.lesson_type, lesson.recurrence].filter(Boolean).join(' · ')}</div>
        <div className={cn.lessonDate}>{lessonDate(lesson)}</div>
        <div><span className={cn.meta}>Педагог: </span>{lesson.teacher || 'Не назначен'}</div>
        {lesson.groups && <div><span className={cn.meta}>Группа: </span>{lesson.groups}</div>}
        {lesson.students && (!lesson.groups || lesson.lesson_type === 'Вводное') && <div><span className={cn.meta}>Учащиеся: </span>{lesson.students}</div>}
      </div>
    ))}
  </div>
)

const ValueChange = ({ label, before, after }: { label: string; before: string; after: string }) => (
  <div className={cn.change}>
    <div className={cn.changeLabel}>{label}</div>
    <div className={cn.valueChange}>
      <span className={cn.oldValue}>{before || '—'}</span>
      <span className={cn.arrow} aria-label="изменено на">→</span>
      <span className={cn.newValue}>{after || '—'}</span>
    </div>
  </div>
)

export const ScheduleChangesCell = ({ value }: { value: ScheduleHistoryPresentation }) => (
  <div className={cn.cell}>
    <div className={cn.scope}>{value.scope}</div>
    {value.action === 'swap' && value.before.map((lesson, index) => (
      <ValueChange key={`${lesson.id}-${index}`} label={lesson.subject || `Занятие ${index + 1}`} before={lessonDate(lesson)} after={lessonDate(value.after[index])} />
    ))}
    {value.action === 'copy' && <ValueChange label="Скопировано на другую дату" before={lessonDate(value.before[0])} after={lessonDate(value.after[0])} />}
    {value.action === 'create' && value.before[0] && <div className={cn.meta}>
      К занятию: {value.before[0].subject} · {lessonDate(value.before[0])}
      {value.before[0].groups ? ` · группа ${value.before[0].groups}` : ''}
    </div>}
    {value.changes.filter(change => value.action !== 'copy' || change.label !== 'Дата и время').map(change => (
      <ValueChange key={change.label} label={change.label} before={change.old} after={change.new} />
    ))}
  </div>
)
